import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import FindRenovate from "./pages/FindRenovate";
import DesignRenovation from "./pages/DesignRenovation";
import Process from "./pages/Process";
import Portfolio from "./pages/Portfolio";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import { SiteImagesProvider } from "./context/SiteImages";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const SEO_META = {
  "/": {
    title: "Kitchen & Bathroom Renovation + Interior Design in Birmingham, AL | KRS Design and Renovation",
    description: "Expert kitchen renovations, bathroom remodeling, whole-home renovations, and interior design across Birmingham, Hoover, Vestavia, Cahaba Heights & Mountain Brook, AL. Licensed & insured. Free consultations."
  },
  "/find-renovate": {
    title: "Find + Renovate a Home in Birmingham, AL | KRS Design and Renovation",
    description: "We help Birmingham-area buyers find fixer-uppers with potential, then design and manage the renovation. Serving Hoover, Vestavia, Cahaba Heights & Mountain Brook, AL."
  },
  "/design-renovation": {
    title: "Home Design + Renovation in Birmingham, AL | KRS Design and Renovation",
    description: "Kitchen, bathroom, primary suite & whole-home renovations with expert interior design in Greater Birmingham, Alabama. Licensed & insured. Free consultations."
  },
  "/process": {
    title: "Our Renovation Process | KRS Design and Renovation, Birmingham AL",
    description: "A clear, organized renovation process for buyers and homeowners across Birmingham, Hoover, Vestavia, Cahaba Heights & Mountain Brook, Alabama."
  },
  "/portfolio": {
    title: "Renovation Portfolio & Before/After Projects | KRS Design, Birmingham AL",
    description: "Explore before-and-after kitchen, bathroom, and whole-home renovation projects by KRS Design and Renovation in Greater Birmingham, Alabama."
  },
  "/about": {
    title: "About KRS Design and Renovation | Birmingham, AL Renovation & Design",
    description: "Real estate, interior design, and renovation under one experienced, licensed & insured team serving Greater Birmingham, Alabama."
  },
  "/contact": {
    title: "Contact & Free Consultation | KRS Design and Renovation, Birmingham AL",
    description: "Start your renovation or home search in Birmingham, Hoover, Vestavia, Cahaba Heights or Mountain Brook, AL. Call 615-497-2166 for a free consultation."
  },
  "/faq": {
    title: "Renovation FAQs | KRS Design and Renovation, Birmingham AL",
    description: "Answers about finding, designing, and renovating homes across Greater Birmingham, Alabama. Licensed & insured. Free consultations."
  }
};

function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = SEO_META[pathname] || SEO_META["/"];
    document.title = meta.title;
    let desc = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", meta.description);
  }, [pathname]);
  return null;
}

function PublicSite() {
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/find-renovate" element={<FindRenovate />} />
          <Route path="/design-renovation" element={<DesignRenovation />} />
          <Route path="/process" element={<Process />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SeoManager />
        <SiteImagesProvider>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/*" element={<PublicSite />} />
          </Routes>
        </SiteImagesProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
